export default __webpack_public_path__ + "static/media/pattern01.7631d721.svg";